<template>
    <a :class="['totem-link', size, color, {'-icon' : icon}]" :style="cssVars" :href="href">
        <span :class="'icon-' + icon" v-if="icon"></span>
        <span class="label" v-html="label"></span>
    </a>
</template>

<script>
    export default {
        name: 'totem-link',
        props: {
            label: String,
            icon: String,
            href: String,
            color: {
                type: String,
                validator: (prop) => ['primary', 'basic', 'teams-blue', 'secondary'].includes(prop),
                default: 'basic'
            },
            size: {
                type: String,
                validator: (prop) => [ 'xsmall', 'small', 'medium', 'large' ].includes(prop),
                default: 'medium'
            },
            width: Number,
            fullWidth: Boolean
        },
        computed: {
            cssVars () {
                if (this.width != null) {
                    return { '--width': this.width + 'px' }
                } else if (this.fullWidth) {
                    return { '--width': '100%' }
                }
                return this.width
            }
        }
    }
</script>

<style lang="scss" scoped>
    .totem-link {
        font-family: PlusJakartaSans-Medium, sans-serif;
        border: none;
        border-radius: 30px;
        padding: 3px 25px;
        height: 30px;
        width: var(--width);
        display: flex;
        justify-content: center;
        align-items: center;

        &:hover {
            cursor: pointer;
            filter: brightness(105%);
        }

        &:active {
            filter: brightness(110%);
        }

        &__content {
            display: flex;
            justify-content: center;
            align-items: center;
        }

    .label {
        text-decoration: none;
        padding-right: 7px
    }

    span[class*="icon-"] {
        padding: 0 10px 0 0;
    }

    &.-icon {
        padding: 10px 15px 10px 15px;
    }

    &.-margin-left {
        margin-left: 10px;
    }

    &.-margin-bottom {
        margin-bottom: 10px;
    }

    /* Colors */

    &.primary {
        background: $lavender;
        border: 2px solid $lavender;
        color: $white;

        &:hover,
        &:active {
            background: $stratos;
            border: 2px solid $stratos;
        }
    }

    &.secondary {
        background: $white;
        color: $stratos;
        border: 2px solid $lavender;

        &:hover,
        &:active {
            background: $stratos;
            color: $white;
            border: 2px solid $stratos;
        }

        [class^="icon-"], [class*=" icon-"] {
            color: $lavender;
        }
    }

    &.basic {
        background: $alto;

        &:hover,
        &:active {
            background-color: $silver;
        }
    }

    &.teams-blue {
        background: $indigo;
        color: $white;
        display: inline-block;
        text-align: center;
        padding: 7px 25px;
    }

    &:disabled {
        color: $black;
        background: $silver_chalice;
        border-color: $manatee;
        opacity: 0.3;
        cursor: default;

        &:hover,
        &:active {
            filter: brightness(100%);
        }
    }

    /* Sizes */

    &.xsmall {
        font-size: 1.2rem;
        min-height: 26px;
        padding: 3px 15px;
    }

    &.small {
        font-size: 1.4rem;
        min-height: 35px;
        height: 100%;

        &.secondary {
            border-width: 1px;
        }
    }

    &.medium {
        font-size: 1.4rem;
        min-height: 30px;
        height: 100%;

        [class*="icon-"] {
            font-size: 1.9rem;

            @supports (hanging-punctuation: first) and (-webkit-appearance: none) {
                font-size: 2.095rem !important;
            }
        }

        [class*="mobile_md"] &,
        [class*="desktop"] & {
            font-size: 1.8rem;
            min-height: 41px;
            height: 100%;
        }
    }

    &.large {
        font-size: 1.4rem;
        min-height: 30px;
        height: 100%;

        [class*="icon-"] {
            font-size: 3rem;
        }
        [class*="mobile_md"] &,
        [class*="desktop"] & {
            font-size: 2rem;
            min-height: 45px;
            height: 100%;
            padding: 0 100px 0 100px;
        }
    }
}

</style>
